import { customerMap } from '@/api';
import { get, post } from '@/common/request';

export interface CustomerResponse {
  id?:number;	// 员工id
  name?: string;	 // 姓名
  avatar?: null;	// 头像
  mobile?: string;	// 手机号
  tenant?: string;	// 租户名称
  email?:	null;	// 邮箱
  isAdmin?:	boolean;	// 是否是管理员
  departmentIds?:	number[];	// 部门id数组
  positionIds?:	number[];	// 岗位id数组
  roleIds?: number [];
  moduleList: Menu[];
}

export interface Menu {
  id?: number;	// 菜单id
  parent?: null; // 父级菜单
  name?: string	// 名称
  encode?: string	// 编码
  icon?: string	 // icon
  uri:	string	// 前端跳转地址
  path?:	string	// 前端跳转地址
  sortNum?:	string	// 排序
  appId?:	number // 应用id
  children?: Menu[] // 子菜单列表
};



interface Config {
 id: number,
 placeCategoryTemplateId: number,
 spotCategoryTemplateId: number,
 placeEditNeedReview: number,
 spotEditNeedReview: number,
 spotOnlineNeedReview: number,
 spotOfflineNeedReview: number
}



class CustomerStore {
  getInfo(): Promise<CustomerResponse> {
    return get(customerMap.get('info'), {}, { needHint: true, needCancel: false });
  }

  getModule(): Promise<CustomerResponse> {
    return get(customerMap.get('module'), {}, { needHint: true, needCancel: false });
  }

  getConfig(): Promise<Config> {
    return post(customerMap.get('config'), {}, { proxyApi: '/resserv', needHint: true });
  }

  userSearch(keyword: string, departmentId?: number): Promise<any> {
    return post(customerMap.get('search'), { keyword, departmentId }, { proxyApi: '/mirage', needHint: true });
  }

  getList(token, options: any) {
    return get(customerMap.get('list'), { token }, { ...options, proxyApi: '/mirage', needHint: true });
  }
}

export default new CustomerStore();
